// 学校api

import {baseRequest} from './base'

/**
 * @desc 查询学校列表
 */
function getSchoolList(params){
  //清除空白字段
  params = utils.common.checkNull(params);
  let tempUrl = '/api/pcWeb/teaSchool/'
  return baseRequest(tempUrl,'get',params);
}

/**
 * @desc 根据学校ID获取学校信息
 */
function getSchoolById(id){
  return baseRequest(`/api/pcWeb/teaSchool/${id}`,'get');
}

/**
 * @desc 新增学校
 */
function addSchool(params){
  return baseRequest(`/api/pcWeb/teaSchool/create`,'post',params);
}

/**
 * @desc 删除学校
 */
function deleteSchool(id){
  return baseRequest(`/api/pcWeb/teaSchool/delete/${id}`,'get');
}

/**
 * @desc 修改学校
 */
function updateSchool(id,params){
  return baseRequest(`/api/pcWeb/teaSchool/update/${id}`,'post',params);
}

/**
 * @desc 学校列表，支持学校名字模糊查询
 */
function searchSchool(params){
  let tempUrl = '/api/pcWeb/teaSchool/selectSearch'
  return baseRequest(tempUrl,'get',params);
}

/**
 * @desc 搜索服务公校
 */
function selectSchoolOfBureau(params){
  let tempUrl = '/api/pcWeb/teaSchool/selectSchoolOfBureau'
  return baseRequest(tempUrl,'get',params);
}



export default {
  getSchoolList: getSchoolList,
  getSchoolById: getSchoolById,
  addSchool: addSchool,
  deleteSchool: deleteSchool,
  updateSchool: updateSchool,
  searchSchool: searchSchool,
  selectSchoolOfBureau: selectSchoolOfBureau,
}